/* Replays callbacks queued by the jQuery shim in layout/theme.liquid.
   Loaded with defer after jquery.min.js, slick.min.js (and flickity.js on
   product pages), so plugins are registered before any callback runs. */
(function (w) {
  var q = w.__jqReadyQueue;
  if (!q || !w.jQuery || !w.jQuery.fn || !w.jQuery.fn.jquery) return;
  w.__jqReadyQueue = { push: function (f) { w.jQuery(f); } };
  for (var i = 0; i < q.length; i++) {
    (function (f) {
      w.jQuery(function ($) {
        try { f.call(w.document, $); } catch (e) { if (w.console) console.error(e); }
      });
    })(q[i]);
  }
})(window);
